export type QueueSong = {
  index?: string | number
  songName?: string
  songimg?: string
  songArtist?: string
  trackTime?: string
  videoUrl?: string
  url?: string
  link?: string
}

export function getQueueSongId(
  song: QueueSong,
  index: number,
) {
  return [
    song.link ?? "",
    song.url ?? "",
    song.songName ?? "",
    song.songArtist ?? "",
    index,
  ].join("|")
}

export function getQueueSongTitle(
  song: QueueSong,
) {
  return song.songName?.trim() || "Sin título"
}

export function getQueueSongArtist(
  song: QueueSong,
) {
  return song.songArtist?.trim() || "Artista desconocido"
}

export function getQueueSongTime(
  song: QueueSong,
) {
  return song.trackTime?.trim() || "--:--"
}